import { TripRef } from "./TripRef";

const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * Whether a trip may still be changed: the "Access Logbook" group allows driver and reason
 * changes for this many days after the trip ended, the rule the EcoApp applies as well.
 */
export function isWithinEditWindow(trip: Pick<TripRef, "start" | "stop">, days: number, now: Date): boolean {
  const ended = trip.stop ?? trip.start;
  return ended.getTime() >= now.getTime() - days * DAY_MS;
}
